import AppRoutes from 'config/routes'
import { AppProviderKc } from 'context/appContextKc'
import { ThemeProvider } from "context/themeContext";
import { MuiThemeProvider } from 'material-ui/styles'
import { AuthProvider } from 'oidc-react'
import PropTypes from "prop-types";
import {
  getAuthorityKCAmbev,
  getAuthorityKCThird,
  getClientIdKc,
  getRedirectUri,
} from "utils/config-environment";

// Não tentar dinamizar métodos aqui, não vai funcionar!
export const buildRedirectUri = (baseUri, url) => {
  const normalizedUrl = url[0] === "/" ? url.slice(1) : url;
  const base = baseUri.replace(/\/$/, "");
  return normalizedUrl ? `${base}/${normalizedUrl}` : base;
};

const KcAuthProvider = ({ realm, url }) => {
  const redirectUri = buildRedirectUri(getRedirectUri(), url);

  const oidcConfAmbev = {
    redirectUri,
    clientId: getClientIdKc(),
    scopes: "openid",
    authority: getAuthorityKCAmbev(),
  };

  const oidcConfThird = {
    redirectUri,
    clientId: getClientIdKc(),
    scopes: "openid",
    authority: getAuthorityKCThird(),
  };

  const returnChildren = () => (
    <ThemeProvider>
      <MuiThemeProvider>
        <AppProviderKc>
          <AppRoutes />
        </AppProviderKc>
      </MuiThemeProvider>
    </ThemeProvider>
  )

    const onSignInCallBack = () => {
      const path = window.location.href.split("?state")
      window.history.replaceState(null, null, path[0])
    }

  //Precisa armazenar o state realm, quando logar, se não
  //não será possível alterar entre realms
  const stateRealm = localStorage.getItem('realm')

  return (
    realm === 'Ambev' || stateRealm === 'Ambev' ?
      <AuthProvider
        {...oidcConfAmbev}
        onSignIn={onSignInCallBack}
      >
        {returnChildren()}
      </AuthProvider>
      :
      <AuthProvider
        {...oidcConfThird}
        onSignIn={onSignInCallBack}
      >
        {returnChildren()}
      </AuthProvider>
  )
}

KcAuthProvider.propTypes = {
  realm: PropTypes.string.isRequired,
  url: PropTypes.any.isRequired
}

export default KcAuthProvider